module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetHigh.044b98e.webp";